export default "https://client.chat.ao.com/1289/beta/without-externals/assets/sounds/newMessage.mp3?24eac5362fcb0d8ea4c53b0b63781cad";